import { render } from "./TronSummary.vue?vue&type=template&id=7961760e&scoped=true"
import script from "./TronSummary.vue?vue&type=script&lang=js"
export * from "./TronSummary.vue?vue&type=script&lang=js"

import "./TronSummary.vue?vue&type=style&index=0&id=7961760e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7961760e"]])

export default __exports__